import { COURSE_HISTORY, STUDENT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const StudentAttendanceSchema = {
	components: {},

	data() {
		return {
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			ENDPOINT: COURSE_HISTORY + "?course_schedule_id=" + this.attendanceRowData?.course_schedule_id,
			tableId: "attendance-table",
			formId: "attendance-form",
			rowData: {},
			tableColumns: [
				{
					title: "Absen",
					type: "absen",
					key: "attendance",
				},
				{
					title: "CLC ID No",
					type: "text",
					key: "clc_id_number",
				},
				{
					title: "Full Name",
					type: "text",
					key: "full_name",
				},
			],
			actionObj: {
				title: "Attendance",
				type: "action",
			},
			options: {
				whatFor: "absen",
				name: "AttendanceTable",
				url: COURSE_HISTORY + "?course_schedule_id=" + this.attendanceRowData?.course_schedule_id,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: false,
				columns: [],
				actions: [],
				filters: [],
				showFilter: false,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 5,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
				disableClickPrevent: true,
			},
		};
	},
	methods: {},
};
